import script from "./PasswordResetModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PasswordResetModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-798d5cfc"]])

export default __exports__